/** @jsx jsx */
import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import AppToaster from '../../../AppToaster';
import {
  DonorInfoFragment,
  useDeleteDonorMutation,
  useForceDeleteDonorMutation,
  useRestoreDonorMutation,
} from '../../../generated/graphql';

type DonorDetailMenuProps = {
  donor: DonorInfoFragment;
  onEdit: () => void;
};

const DonorDetailMenu = ({ donor, onEdit }: DonorDetailMenuProps) => {
  const { id } = donor;
  const options = {
    variables: {
      id,
    },
  };
  const [isForceDeleteAlertOpen, setIsForceDeleteAlertOpen] = useState(false);

  const [deleteDonor, { loading: deleting }] = useDeleteDonorMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${donor.name}  wurde in den Papierkorb gelegt`),
  });
  const [restoreDonor, { loading: restoring }] = useRestoreDonorMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${donor.name}  wurde wiederhergestellt`),
  });
  const [forceDeleteDonor, { loading: forceDeleting }] = useForceDeleteDonorMutation({
    ...options,
    onCompleted: () => AppToaster.success(`${donor.name}  wurde endgültig entfernt`),
  });

  if (!!donor.deleted_at) {
    return (
      <Fragment>
        <Alert
          isOpen={isForceDeleteAlertOpen}
          cancelButtonText="Abbrechen"
          confirmButtonText="Entfernen"
          icon={IconNames.DELETE}
          intent={Intent.DANGER}
          onClose={() => setIsForceDeleteAlertOpen(false)}
          onConfirm={forceDeleteDonor as any}
        >
          <p>Soll dieser Spender wirklich undwiderruflich entfernt werden?</p>
        </Alert>
        <Button
          text="Wiederherstellen"
          icon={IconNames.OFFLINE}
          css={styles.headerButton}
          onClick={restoreDonor as any}
          loading={restoring}
        />
        <Popover
          position={Position.BOTTOM}
          content={
            <Menu>
              <MenuItem text="Bearbeiten" icon={IconNames.EDIT} onClick={onEdit} />
              <MenuItem
                text="Entfernen"
                icon={IconNames.DELETE}
                intent={Intent.DANGER}
                onClick={() => setIsForceDeleteAlertOpen(true)}
              />
            </Menu>
          }
        >
          <Button icon={IconNames.MORE} css={styles.headerButton} loading={forceDeleting} />
        </Popover>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Button text="Bearbeiten" icon={IconNames.EDIT} css={styles.headerButton} onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteDonor as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} css={styles.headerButton} loading={deleting} />
      </Popover>
    </Fragment>
  );
};

export default DonorDetailMenu;

const styles = {
  statusTag: css`
    margin-left: 10px;
  `,
  headerButton: css`
    margin-left: 10px;
  `,
};
